import { ILoginParams } from '../types/ILoginParams';
import { ISessionInfo } from '../types/ISessionInfo';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class InitializeServerWithActiveDirectoryUserRequest extends Request<ILoginParams, ISessionInfo> {
  constructor(params: ILoginParams) {
    super('initializeServerWithActiveDirectoryUser', params);
  }
}
